import UserProfile from "../Models/UserProfile";
import { Companies_Agents } from "../Models/Agents";
import { EsaedroChangePasswordObject } from "../Utils/EsaedroHelper";

export default class cubeApiClient
{
    //apiUrl:string = "http://webcube.westeurope.cloudapp.azure.com/";
    apiUrl:string = process.env.NODE_ENV === 'development' ? "https://dev.e-cube.it/": (window.location.origin + "/")
    //apiUrl:string = "http://localhost/cubewebAPIService/";
    //apiUrl:string = "https://www.thinkweb.cloud/";    
    //apiUrl:string = "https://dev.e-cube.it/";
    //apiUrl:string = "https://api.e-cube.it/";

    constructor()
    {
       //alert(window.location.origin);
    }
    async login(username:string,password:string)
    {        
        var p:string;

        //alert(this.apiUrl);

        p="grant_type=password&username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password);

        const response = await fetch(this.apiUrl+'Token',
            {
                method:'POST', 
                headers:{
                            'Accept':'application/json',
                            'Content-Type':'application/x-www-form-urlencoded'}, 
                body:p});
        const data = await response.json();

        if (response.ok)
        {
            return data;
        }
        else  {
            throw data.error_description
        }
    }
    
    async changePassword(newPassObj : EsaedroChangePasswordObject, tokenAPI:string)
    {
        const response = await fetch(this.apiUrl+'api/account/ChangePassword',
            {
                method:'POST', 
                headers:{
                    'Authorization':'bearer ' + tokenAPI,
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                }, 
                body:JSON.stringify(newPassObj)
            });
        

        if (response.ok) {
            return true;
        }
        // Se response non è ok mando un alert con cosa è andato storto
        else 
        {
            const errorData = 'Password sbagliata'
            throw errorData
        }

    }

    // Fa sempre una post all'url con l'aggiunta di /query. Opzionalmente passa la vista di filtraggio
    async getItems(resourceURL:string,tokenAPI:string,resourceViewBody?:string)
    {
        if (!resourceViewBody || resourceViewBody == "") resourceViewBody = "[]"
        var urlToUse = (resourceURL.includes("RecordSelection")) ? 
                            this.apiUrl+resourceURL.replace("?RecordSelection","/query?RecordSelection") 
                        :(resourceURL.includes("?Page")) ? 
                            this.apiUrl+resourceURL.replace("?Page","/query?Page") 
                        :this.apiUrl+resourceURL+"/query"
        try{
            const response = await fetch(urlToUse,
                {
                    method:'POST',
                    headers:
                    {
                        'Authorization':'bearer ' + tokenAPI,
                        'Content-Type':'application/json'
                    },
                    body: resourceViewBody
                });

            try {
            
                const data = await response.json();

                if (response.ok) {
 
                    var dataToRet = data[0]
                    if (dataToRet.Results) {
                        dataToRet = data[0].Results
                        if (dataToRet.objectList) {
                            return dataToRet.objectList
                        }
                        else return dataToRet
                    }
                    else return dataToRet
                }
                
                // Se response non è ok mando un alert con cosa è andato storto
                else 
                {
                    alert(resourceURL + ' ' + data.ExceptionMessage)
                    throw data.ExceptionMessage
                }
            }
            catch(errResponseJSON) {
                //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
                if (!response.ok) {
                    alert('Errore nel JSON Response alla chiamata: ' + resourceURL + '. ' + errResponseJSON)
                throw errResponseJSON
                }
            }
        }
        catch(errFetch) {
            alert('Errore nel fetch alla chiamata: ' + resourceURL + '. ' + errFetch)
            throw errFetch
        }
    }

    async deleteObject(objToDel:any, objUrl: string, tokenAPI:string)
    {
        try{
            const response = await fetch(this.apiUrl+objUrl,
                {
                    method:'DELETE',
                    headers:
                    {
                        'Authorization':'bearer ' + tokenAPI,
                        'Accept':'application/json',
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify(objToDel)
                });
            try {
            
                const data = await response.json();

                if (response.ok) return data
                // Se response non è ok mando un alert con cosa è andato storto
                else 
                {
                    alert(objUrl + ' ' + data.ExceptionMessage)
                    throw data.ExceptionMessage
                }
            }
            catch(errResponseJSON) {
                //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
                if (!response.ok) {
                    alert('Errore nel JSON Response alla chiamata: ' + objUrl + '. ' + errResponseJSON)
                throw errResponseJSON
                }
            }
        }
        catch(errFetch) {
            alert('Errore nel fetch alla chiamata: ' + objUrl + '. ' + errFetch)
            throw errFetch
        }
    }

    // In teoria da eliminare, non dovrebbe servire. Tenuta in caso servisse per EO/eTeVe
    async updateCompanies_Agents(agent:Companies_Agents,tokenAPI:string)
    {
        try{
            const arrP=[agent]
                    

            const response = await fetch(this.apiUrl+'api/sys/Companies_Agents',
                {
                    method:'POST',
                    headers:
                    {
                        'Authorization':'bearer ' + tokenAPI,
                        'Accept':'application/json',
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify(arrP)
                });
            const data = await response.json();

            return data;

        }
        catch(err){
            alert("UpdateCompaniesAgents" + err)
            return err;
        }

    }

    async updateObject(myObject: any, myResUrl: string, tokenAPI:string)
    {
        try{

            const arrP=[myObject]
                    
            const response = await fetch(this.apiUrl+myResUrl,
                {
                    method:'POST',
                    headers:
                    {
                        'Authorization':'bearer ' + tokenAPI,
                        'Accept':'application/json',
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify(arrP)
                });
            try {
                
                const data = await response.json();

                if (response.ok) return data
                // Se response non è ok mando un alert con cosa è andato storto
                else 
                {
                    alert(myResUrl + ' ' + data.ExceptionMessage)
                    throw data.ExceptionMessage
                }
            }
            catch(errResponseJSON) {
                //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
                if (!response.ok) {
                    alert('Errore nel JSON Response alla chiamata: ' + myResUrl + '. ' + errResponseJSON)
                throw errResponseJSON
                }
            }
        }
        catch(errFetch) {
            alert('Errore nel fetch alla chiamata: ' + myResUrl + '. ' + errFetch)
            throw errFetch
        }
    }

    async updateObjects(myObjects: any[], myResUrl: string, tokenAPI:string)
    {
        try{

            const arrP=myObjects
            const bodyToSend=JSON.stringify(arrP)
                    
            const response = await fetch(this.apiUrl+myResUrl,
                {
                    method:'POST',
                    headers:
                    {
                        'Authorization':'bearer ' + tokenAPI,
                        'Accept':'application/json',
                        'Content-Type':'application/json'
                    },
                    body:bodyToSend
                });
            try {
                
                const data = await response.json();

                if (response.ok) return data
                // Se response non è ok mando un alert con cosa è andato storto
                else 
                {
                    alert(myResUrl + ' ' + data.ExceptionMessage)
                    throw data.ExceptionMessage
                }
            }
            catch(errResponseJSON) {
                //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
                if (!response.ok) {
                    alert('Errore nel JSON Response alla chiamata: ' + myResUrl + '. ' + errResponseJSON)
                throw errResponseJSON
                }
            }
        }
        catch(errFetch) {
            alert('Errore nel fetch alla chiamata: ' + myResUrl + '. ' + errFetch)
            throw errFetch
        }
    }

    async changeUserProfile(profile:UserProfile,tokenAPI:string)
    {
        try{
            const arrP=[new UserProfile(
                    profile.customer_ID,
                    profile.UserId,
                    profile.AgenteID,
                    profile.UserName,
                    profile.CompanyName,
                    profile.CompanyAddress,
                    profile.ERPCompanyCode,
                    profile.ProtectionLevel,
                    profile.ProductCode,
                    profile.Roles)]
                    

            const response = await fetch(this.apiUrl+'api/sys/UserProfile',
                {
                    method:'POST',
                    headers:
                    {
                        'Authorization':'bearer ' + tokenAPI,
                        'Accept':'application/json',
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify(arrP)
                });
            const data = await response.json();

            return data;
        }
        catch(err){
            alert("changeUserProfile" + err)
            return [{id:999,title:"ERROREACCIO"}];
        }
    }
}